import React from "react";
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import { useNavigate } from "react-router-dom";
import normatecaStore from "../../../stores/normatecaStore";

export default function Acoordion(param){
    
    const navigate= useNavigate();
    // store - zuntand
    const {visMenu1,visMenu2,visMenu3,visMenu4,setVisMenuP} =
    normatecaStore((state) =>( { 
        visMenu1: state.visMenu1,
        visMenu2: state.visMenu2,
        visMenu3: state.visMenu3,
        visMenu4: state.visMenu4,
        setVisMenuP: state.setVisMenuP,
    })); 
    
    const visualizaMenu=()=>{
      let menuI= param.menu;
      if (param.indi!=="1"){
        menuI.nivel2.map((mn,index)=>{
            mn.visualiza=false;
            if (mn.nivel3){
                    mn.nivel3.map ((m1,index1)=>{
                    m1.visualiza=false;
                    if(m1.nivel4){
                        m1.nivel4.map ((m2,index2)=>{
                            m2.visualiza=false;
                        })
                    }
                })
          }
        })
      }
      setVisMenuP(param.indi).catch(null);
    }
    const openCloseMenu=(indices)=>{
        let ind= indices.toString().split("-");
        let menuI= param.menu;
        switch(ind.length){
           case 1:
            if (menuI.nivel2[ind[0]].visualiza){
                menuI.nivel2[ind[0]].visualiza= false;
            }
            else{
                menuI.nivel2[ind[0]].visualiza= true;
            }
            break;
            case 2:
                menuI.nivel2[ind[0]].nivel3[ind[1]].visualiza= !menuI.nivel2[ind[0]].nivel3[ind[1]].visualiza;//? false:true
            break;
            case 3:
                menuI.nivel2[ind[0]].nivel3[ind[1]].nivel4[ind[2]].visualiza= !menuI.nivel2[ind[0]].nivel3[ind[1]].nivel4[ind[2]].visualiza;//? false:true
            break;
      }
      if (param.indi==="4"){
        setVisMenuP("vis4").catch(null);
      }
    }
    const cambiaContenido =(opcVis, indices)=>{
        navigate("/app/normateca/menu=" + opcVis + "_" + indices);
    }       
    return(
             /* menu */
                <Accordion  className={param?.indi==="4" ? "divAcoor2": param?.indi==="2"? "divAcoorMNor": param?.indi==="3"? "divAcoorMan": "divAcoor1"}  as={"ul"} >
                    <div id={"miAc" + "_" + param.indi } key={"miAc" + "_" + param.indi }>
                        <AccordionItem key={0}>
                        <AccordionHeader  className={param?.indi==="4" ? "btnAcoor2 display-flex lineH-n height-1-5rem": "btnAcoor display-flex lineH-n height-1-5rem"} onClick={visualizaMenu}>
                             <div id={"miAcNom" + "_" + param.indi }>{param.menu?.nombre}&nbsp;&nbsp;
                             {param?.indi==="1"?
                                visMenu1? <span className="inegi-nav-despa alignSelf-center lineH-n"></span>:<span className="inegi-nav-desp alignSelf-center lineH-n"></span>
                                :
                                param?.indi==="2"?
                                    visMenu2? <span className="inegi-nav-despa alignSelf-center lineH-n"></span>:<span className="inegi-nav-desp alignSelf-center lineH-n"></span>
                                    :
                                    param?.indi==="3"?
                                        visMenu3? <span className="inegi-nav-despa alignSelf-center lineH-n"></span>:<span className="inegi-nav-desp alignSelf-center lineH-n"></span>
                                        :
                                        param?.indi==="4"?
                                            visMenu4? <span className="inegi-nav-despa alignSelf-center lineH-n"></span>:<span className="inegi-nav-desp alignSelf-center lineH-n"></span>
                                        :
                                        null
                             }
                             </div>
                        </AccordionHeader>
                        <AccordionBody className={param.indi==="1"? visMenu1? 'display-initial' : 'display-none' 
                                                :
                                                param.indi==="2"?
                                                    visMenu2? 'display-initial' : 'display-none' 
                                                :
                                                param.indi==="3"?
                                                    visMenu3? 'display-initial' : 'display-none' 
                                                :
                                                param.indi==="4"?
                                                    visMenu4? 'display-initial' : 'display-none' 
                                                :
                                                null
                                        } >
                            <div id= {"div" + param.indi} className="accordion-body backColor-white boxSha acoordionScroll" key={"div" + param.indi}  >
                            {param.menu?.nivel2.map((m,index)=>(
                                   <AccordionItem key={"aci" + "_" + param.indi + index.toString()}>
                                    {m.nivel3?.length===0 ?
                                            <div id={"miNom" + "_" + param.indi+ index.toString() } >
                                                <button id={"mib" + "_" + param.indi + index.toString()} type="button" onClick={()=>cambiaContenido(m.id, index)} className='accordion-body linkAcoor1 backColor-gray1'>
                                                   <div id={"dvmib" + "_" + param.indi + index.toString()}>{m.nombre}</div>
                                                </button>
                                            </div>
                                    :
                                        <div key={"mh" + index.toString()}>
                                            <AccordionHeader key={"mah" + index.toString()} className='linkAcoor1 backColor-gray1' onClick={()=> openCloseMenu(index)}>
                                                <div id={"divDF2" + "_" + param.indi + index.toString()} className="display-flex" key={"divDF2" + index.toString()}>
                                                    <div className="width-92">{m.nombre}</div>
                                                    {m.visualiza? <div className="inegi-nav-despa alignSelf-center"></div> :<div className="inegi-nav-desp alignSelf-center"></div>}
                                                </div> 
                                            </AccordionHeader>
                                            <AccordionBody key={"ab1" + index.toString()} className={m.visualiza?  'display-initial' : 'display-none'} >
                                             {m.nivel3?.map((m1,indexm1)=>(
                                                
                                                <AccordionItem key={"ai1" + indexm1.toString()}>
                                                    
                                                    {m1['nivel4'] === undefined || m1.nivel4?.length === 0?
                                                        <div id={"divms" + "_" + param.indi + indexm1.toString()} key={"divms" + "_" + param.indi + indexm1.toString()}>
                                                        <button type="button"  id={"btnm1" + "_" + param.indi + indexm1.toString()} key={"btnm1" + "_" + param.indi + indexm1.toString()} onClick={()=>cambiaContenido(m1.id, index + "-" + indexm1)} className='accordion-body linkAcoor1 padNiv1 backColor-gray2'>
                                                        <div id={"mi2Nom" + "_" + param.indi + indexm1.toString() }>{m1.nombre}</div>
                                                        </button>
                                                        </div>
                                                    :
                                                        <div key={"m1" + indexm1.toString()}>
                                                            <AccordionHeader key={"ac" + indexm1.toString()} className='linkAcoor1 padNiv1 backColor-gray2' onClick={()=> openCloseMenu(index + "-" + indexm1)}>
                                                            <div id={"divDF4" + "_" + param.indi + indexm1.toString()} className="display-flex" key={"divDF4" + indexm1.toString()}>
                                                                <div className="width-90">{m1.nombre}</div>
                                                                {m1.visualiza? <div className="inegi-nav-despa alignSelf-center"></div> :<div className="inegi-nav-desp alignSelf-center"></div>}
                                                            </div>
                                                            </AccordionHeader>
                                                            <AccordionBody key={"ab" + indexm1.toString()} className={m1.visualiza?'display-initial' : 'display-none'} >
                                                                {m1.nivel4?.map((m2,indexm2)=>(
                                                                    <div id={"divmt" + "_" + param.indi + indexm2.toString()} key={"divmt" + "_" + param.indi + indexm2.toString()}>
                                                                    <button type="button" id={"btnm2" + "_" + param.indi +  indexm2.toString()} className='accordion-body linkAcoor1 padNiv2 ' key={"btnm2" + indexm2.toString()} onClick={()=>cambiaContenido(m2.id, index + "-" + indexm1 + "-" + indexm2)}>
                                                                        <div id={"mi3Nom" + "_" + param.indi + indexm2.toString() }>{m2.nombre}</div>
                                                                    </button>
                                                                    </div>
                                                                ))}
                                                            </AccordionBody>
                                                        </div>
                                                    }
                                                    
                                                </AccordionItem>
                                                
                                            ))}
                                            </AccordionBody>
                                        </div>
                                    }
                                    </AccordionItem>
                                   
                                ))}
                                </div>
                            </AccordionBody>
                        </AccordionItem>
                    </div>
                </Accordion>
    ) 
}




